import { Component, Input, OnInit } from '@angular/core';
import { AppStatus, AppStatusEnum } from '@app/models';
import { environment } from '@src/environments/environment';

@Component({
  selector: 'qb-app-status',
  templateUrl: './app-status.component.html',
  styleUrls: ['./app-status.component.scss'],
  imports: [],
})
export class AppStatusComponent implements OnInit {
  @Input() status?: AppStatus;
  @Input() statusId: number = 0;
  @Input() questionnaireTypeId: number;
  is = AppStatusEnum;

  get statusLabel(): string {
    if (this.status?.toString() === AppStatusEnum.LEGACY) {
      return 'Rated (Legacy)';
    }
    if (this.status.APPROVED)
      if (environment.site !== 'lausd') {
        if (this.questionnaireTypeId === 1) {
          /** PREQUAL */
          return 'Rated';
        } else if (this.questionnaireTypeId === 2) {
          /** CUPCCAA */
          return 'Listed';
        }
      }

    // Add 'New' based on App Type
    if (this.status?.NEW) {
      if (environment.site === 'lausd') {
        switch (this.questionnaireTypeId) {
          case 1:
            return 'New Prime Contractor App';
          case 2:
            return 'New Subcontractor App';
          case 3:
            return 'New Safety App';
          default:
            return null;
        }
      } else {
        switch (this.questionnaireTypeId) {
          case 1:
            return 'New Prequalification App';
          case 2:
            return 'New CUPCCAA App';
          default:
            return null;
        }
      }
    }

    return this.status.toString();
  }

  constructor() {}

  ngOnInit(): void {
    if (this.status == undefined && this.statusId <= 0) {
      throw Error('AppStatusComponent must be provided with a status string or a statusId');
    }
    if (this.statusId > 0) {
      this.status = new AppStatus(AppStatusEnum.NEW);
      switch (this.statusId) {
        case 1:
          // this.status = new AppStatus(AppStatusEnum.NEW);
          break;
        case 101:
        case 102:
        case 104:
          this.status.set(AppStatusEnum.SUBMITTED);
          break;
        case 103:
          this.status.set(AppStatusEnum.RETURNED);
          break;
        case 105:
        case 106:
          this.status.set(AppStatusEnum.INREVIEW);
          break;
        case 107:
          this.status.set(AppStatusEnum.READYFORFINALREVIEW);
          break;
        case 201:
          this.status.set(AppStatusEnum.APPROVED);
          break;
        case 202:
          this.status.set(AppStatusEnum.LEGACY);
          break;
        case 301:
          this.status.set(AppStatusEnum.CLOSEDOTHER);
          break;
        case 302:
        case 303:
          this.status.set(AppStatusEnum.CLOSED);
          break;
        case 401:
        case 402:
        case 403:
          this.status.set(AppStatusEnum.ARCHIVED);
          break;
        default:
          throw new Error('This status is not compatible with an application. ');
        // this.status = "Unknown Status"; // Optional default case
      }
    }
  }
}
